import React from "react";
import "./SignUp.css";

import { Button, makeStyles, TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
}));

const SignIn = ({
  signIn,
  username,
  setUserName,
  email,
  setEmail,
  password,
  setPassword,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className='p-3 w-96 form mx-auto flex justify-center items-center  flex-col'>
      <form className={`${classes.root} bg-white h-72 shadow-xl rounded-xl`}>
        <TextField
          label='Email'
          variant='filled'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type='email'
          required
        />
        <TextField
          label='Password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          variant='filled'
          type='password'
          required
        />

        <div className='pt-2'>
          <Button onClick={() => history.push("/")} variant='contained'>
            Back
          </Button>
          <Button
            type='submit'
            onClick={signIn}
            className='signIn'
            variant='contained'
            color='primary'>
            Login
          </Button>
        </div>
        <p>
          Dont have an account?{" "}
          <span
            className='font-bold cursor-pointer'
            onClick={() => history.push("/signUp")}>
            Signup
          </span>
        </p>
      </form>
    </div>
  );
};

export default SignIn;
